import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconH1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconH1"><Path d="M2.5 4.5V12V19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M13.5 4.5V12V19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M13.5 12H2.5" stroke="currentColor" strokeLinecap="square"/><Path d="M18.5 13.5L21.25 10.5H21.5V19.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconH1;
